/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Pricedrops1Inputs */

const id_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penurunan Harga`)
};

const ms_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penurunan Harga`)
};

const da_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfald`)
};

const de_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preissenkungen`)
};

const en_us2_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Drops`)
};

const es_es2_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajadas de Precio`)
};

const es_mx2_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bajas de precio`)
};

const fil_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbaba ng Presyo`)
};

const fr_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baisses de prix`)
};

const it_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calo Prezzi`)
};

const hu_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árcsökkenések`)
};

const nl_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijsdalingen`)
};

const no_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfall`)
};

const pl_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spadki cen`)
};

const pt_br2_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Drops`)
};

const pt_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quedas de Preço`)
};

const ro_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scăderi de preț`)
};

const fi_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnanlaskut`)
};

const sv_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfall`)
};

const vi_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá`)
};

const tr_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat Düşüşleri`)
};

const cs_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poklesy cen`)
};

const bg_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спадове на цените`)
};

const ru_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снижения цен`)
};

const uk_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зниження цін`)
};

const ar_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انخفاضات الأسعار`)
};

const hi_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य में गिरावट`)
};

const th_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาลดลง`)
};

const ja_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値下がり`)
};

const zh_cn2_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Drops`)
};

const zh_hant1_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Drops`)
};

const ko_notifications_simple_pricedrops1 = /** @type {(inputs: Notifications_Simple_Pricedrops1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격 인하`)
};

/**
* | output |
* | --- |
* | "Price Drops" |
*
* @param {Notifications_Simple_Pricedrops1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_pricedrops1 = /** @type {((inputs?: Notifications_Simple_Pricedrops1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Pricedrops1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_pricedrops1(inputs)
	if (locale === "ms") return ms_notifications_simple_pricedrops1(inputs)
	if (locale === "da") return da_notifications_simple_pricedrops1(inputs)
	if (locale === "de") return de_notifications_simple_pricedrops1(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_pricedrops1(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_pricedrops1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_pricedrops1(inputs)
	if (locale === "fil") return fil_notifications_simple_pricedrops1(inputs)
	if (locale === "fr") return fr_notifications_simple_pricedrops1(inputs)
	if (locale === "it") return it_notifications_simple_pricedrops1(inputs)
	if (locale === "hu") return hu_notifications_simple_pricedrops1(inputs)
	if (locale === "nl") return nl_notifications_simple_pricedrops1(inputs)
	if (locale === "no") return no_notifications_simple_pricedrops1(inputs)
	if (locale === "pl") return pl_notifications_simple_pricedrops1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_pricedrops1(inputs)
	if (locale === "pt") return pt_notifications_simple_pricedrops1(inputs)
	if (locale === "ro") return ro_notifications_simple_pricedrops1(inputs)
	if (locale === "fi") return fi_notifications_simple_pricedrops1(inputs)
	if (locale === "sv") return sv_notifications_simple_pricedrops1(inputs)
	if (locale === "vi") return vi_notifications_simple_pricedrops1(inputs)
	if (locale === "tr") return tr_notifications_simple_pricedrops1(inputs)
	if (locale === "cs") return cs_notifications_simple_pricedrops1(inputs)
	if (locale === "bg") return bg_notifications_simple_pricedrops1(inputs)
	if (locale === "ru") return ru_notifications_simple_pricedrops1(inputs)
	if (locale === "uk") return uk_notifications_simple_pricedrops1(inputs)
	if (locale === "ar") return ar_notifications_simple_pricedrops1(inputs)
	if (locale === "hi") return hi_notifications_simple_pricedrops1(inputs)
	if (locale === "th") return th_notifications_simple_pricedrops1(inputs)
	if (locale === "ja") return ja_notifications_simple_pricedrops1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_pricedrops1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_pricedrops1(inputs)
	return ko_notifications_simple_pricedrops1(inputs)
});
export { notifications_simple_pricedrops1 as "notifications.simple.priceDrops" }